import sample_1 from './100_45621.jpg';
import sample_2 from './100_45656.jpg';
import sample_3 from './100_45657.jpg';

export const dynamicReflectImpressions = {
    sample_1,
    sample_2,
    sample_3,
};
